export default __webpack_public_path__ + "static/media/netlify.1cc19144.webp";